/* src/app/components/doc-viewer-new/form-controls/checkbox/checkbox.component.scss */
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.container > mat-checkbox {
  width: 100;
}
/*# sourceMappingURL=checkbox.component.css.map */
